var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { logger } from '../utilites/logger';
import { EnumPurchaseEventLsListenedProps } from '../models/EnumPurchaseEventLsListenedProps';
var prefix = 'ark_modules:';
var LocalStorageServiceClass = /** @class */function () {
  function LocalStorageServiceClass() {
    this.data = {};
    this.prefix = prefix;
    this.eventCallbacks = {};
    this.getItem = this.getItem.bind(this);
    this.setItem = this.setItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.clear = this.clear.bind(this);
    this.checkStorageListening = this.checkStorageListening.bind(this);
    this.addStorageListening = this.addStorageListening.bind(this);
    this.removeStorageListening = this.removeStorageListening.bind(this);
    this.handleStorageListening = this.handleStorageListening.bind(this);
  }
  LocalStorageServiceClass.prototype.setItem = function (key, value, noprefix) {
    if (noprefix === void 0) {
      noprefix = false;
    }
    if (!noprefix) {
      key = "".concat(this.prefix).concat(key);
    }
    if (typeof window === 'undefined') {
      this.data[key] = String(value);
    } else {
      try {
        window.localStorage.setItem(key, String(value));
      } catch (e) {
        logger.log(e);
      }
    }
  };
  LocalStorageServiceClass.prototype.getItem = function (key, noprefix) {
    var _a;
    if (noprefix === void 0) {
      noprefix = false;
    }
    if (!noprefix) {
      key = "".concat(this.prefix).concat(key);
    }
    if (typeof window === 'undefined') {
      return key ? (_a = this.data) === null || _a === void 0 ? void 0 : _a[key] : null;
    }
    var value = key ? window.localStorage.getItem(key) : null;
    if (!value || value === 'undefined' || value === 'null') {
      return null;
    }
    return value;
  };
  LocalStorageServiceClass.prototype.removeItem = function (key, prefix) {
    if (prefix === void 0) {
      prefix = true;
    }
    key = prefix ? "".concat(this.prefix).concat(key) : key;
    if (typeof window === 'undefined') {
      delete this.data[key];
    } else {
      window.localStorage.removeItem(key);
    }
  };
  LocalStorageServiceClass.prototype.clear = function () {
    if (typeof window === 'undefined') {
      this.data = {};
    } else {
      window.localStorage.clear();
    }
  };
  LocalStorageServiceClass.prototype.dispatchEvent = function (key, newValue, noprefix) {
    if (noprefix === void 0) {
      noprefix = false;
    }
    if (typeof window === 'undefined') return;
    var oldValue = this.getItem(key, noprefix);
    this.setItem(key, newValue, noprefix);
    var event = new StorageEvent('storage', {
      key: key,
      oldValue: oldValue,
      newValue: newValue
    });
    window.dispatchEvent(event);
  };
  /**
   * Adds a localStorage event listener
   *
   * @remarks
   * Make sure to also call removeEvent to avoid memory leaks.
   *
   * Event is not fired or catchable under Chrome, Edge and Safari if domain was modified through script.
   *
   * Safari Incognito is not supported
   * @param handler - the useCallback or regular function to be called
   * @param options - eventListener options
   */
  LocalStorageServiceClass.prototype.addStorageListening = function (callbackObj, targetWindow, handler, options) {
    if (targetWindow === void 0) {
      targetWindow = window;
    }
    if (handler === void 0) {
      handler = this.handleStorageListening;
    }
    if (options === void 0) {
      options = {
        capture: true
      };
    }
    if (this.checkStorageListening() || !callbackObj) {
      return;
    }
    if (typeof window === 'undefined' || !window.localStorage) {
      logger.warn('Could not add storage listening.');
      return;
    }
    var prevEventCallbacks = Object.assign({}, this.eventCallbacks);
    if (callbackObj) {
      this.eventCallbacks = __assign(__assign({}, this.eventCallbacks), callbackObj);
    }
    if (!Object.keys(prevEventCallbacks).length) {
      var selectedWindow = targetWindow || window;
      selectedWindow.addEventListener('storage', handler, options || false);
    }
    if (!this.checkStorageListening()) {
      // Add mark for listener check in case of not gameplay gems purchase
      this.setItem(EnumPurchaseEventLsListenedProps.LS_LISTENER_IS_ON_PROP, true);
    }
  };
  /**
   * Check id localStorage event listener is on
   */
  LocalStorageServiceClass.prototype.checkStorageListening = function () {
    return Boolean(this.getItem(EnumPurchaseEventLsListenedProps.LS_LISTENER_IS_ON_PROP));
  };
  /**
   * Removes a localStorage event listener
   *
   * @remarks
   * Safari Incognito is not supported
   * @param handler - the useCallback or regular function referenced
   * @param options - eventListener options
   */
  LocalStorageServiceClass.prototype.removeStorageListening = function (callbackEventName, targetWindow, handler, options) {
    if (targetWindow === void 0) {
      targetWindow = window;
    }
    if (handler === void 0) {
      handler = this.handleStorageListening;
    }
    if (options === void 0) {
      options = {
        capture: true
      };
    }
    if (typeof window === 'undefined' || !window.localStorage) {
      logger.warn('Could not remove storage listening.');
      return;
    }
    if (callbackEventName && this.eventCallbacks[callbackEventName]) {
      delete this.eventCallbacks[callbackEventName];
      this.removeItem(callbackEventName);
    }
    if (!Object.keys(this.eventCallbacks).length) {
      var selectedWindow = targetWindow || window;
      selectedWindow.removeEventListener('storage', handler, options || false);
      // Remove mark for listener check in case of not gameplay gems purchase
      this.removeItem(EnumPurchaseEventLsListenedProps.LS_LISTENER_IS_ON_PROP);
    }
  };
  /**
   * Handles a localStorage event listener when it's added, actual logic is in ./LocalStorageListenerLogic.ts
   */
  LocalStorageServiceClass.prototype.handleStorageListening = function (ev) {
    return __awaiter(this, void 0, void 0, function () {
      var key, newValue, oldValue, keyUnprefixed, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            key = ev.key, newValue = ev.newValue, oldValue = ev.oldValue;
            if (this.getItem(key) === undefined || newValue === oldValue) {
              return [2 /*return*/];
            }
            keyUnprefixed = key ? key.replace(new RegExp("^".concat(this.prefix), 'gi'), '') : null;
            if (!(keyUnprefixed && Object.keys(this.eventCallbacks).some(function (cb) {
              return cb === keyUnprefixed;
            }) && Object.prototype.hasOwnProperty.call(this.eventCallbacks, keyUnprefixed) && typeof this.eventCallbacks[keyUnprefixed] === 'function')) return [3 /*break*/, 4];
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, this.eventCallbacks[keyUnprefixed](ev)];
          case 2:
            _a.sent();
            return [3 /*break*/, 4];
          case 3:
            err_1 = _a.sent();
            logger.error('Could not execute storage listening handler function.', err_1);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  };
  return LocalStorageServiceClass;
}();
export var LocalStorageService = new LocalStorageServiceClass();
// LS PROP FOR GAME PURCHASE REQUEST
export var lsSetGamePurchaseRequest = function (value) {
  LocalStorageService.setItem(EnumPurchaseEventLsListenedProps.GAME_PURCHASE_REQUEST, value);
};
export var lsRemoveGamePurchaseRequest = function () {
  LocalStorageService.removeItem(EnumPurchaseEventLsListenedProps.GAME_PURCHASE_REQUEST);
};
// DIRECT DISPATCH LS EVENT FOR GAME PURCHASE REQUEST
export var lsDispatchGamePurchaseRequest = function (value) {
  LocalStorageService.dispatchEvent(EnumPurchaseEventLsListenedProps.GAME_PURCHASE_REQUEST, value);
  lsRemoveGamePurchaseRequest();
};